import { DvmModule, Viewer3dService } from '@3ddv/ngx-dvm-internal';
import { Component, inject, OnInit, Signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DvmService } from '@services/dvm.service';

@Component({
  selector: 'app-viewer3d',
  standalone: true,
  imports: [
    DvmModule
  ],
  templateUrl: './viewer3d.component.html',
  styleUrl: './viewer3d.component.css'
})
export class Viewer3dComponent implements OnInit{

  // SERVICES
  private readonly dvm:        DvmService      = inject(DvmService);
  private readonly route:      ActivatedRoute  = inject(ActivatedRoute);  

  // GLOBAL STATE
  public  readonly viewer3d:   Viewer3dService = this.dvm.viewer3d; // Viewer3D Service
  public  readonly showViewer: Signal<boolean> = this.dvm.is3d; // Show Viewer Signal

  // LIFECYCLE HOOKS
  ngOnInit(): void {

    this.initComponent();
    
  }

  // METHODS
  private initComponent(): void {

    const viewId: string | null  = this.route.snapshot.queryParamMap.get('view_id') ? atob(this.route.snapshot.queryParamMap.get('view_id')!) : null;

    if(viewId) this.openParamView(viewId!);

  }

  private openParamView( viewId: string ): void {
    
    this.viewer3d.waitInitialize().subscribe((): void => {

      this.dvm.load3dView(viewId).subscribe();

    })
    
  }

}
